import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricImprShareGha extends MetricBase {
    constructor() {
        super({
            field: "metric_impr_share_gha",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.imprShareGha.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.imprShareGha.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.imprShareGha.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricImprShareGha;
